import { render, staticRenderFns } from "./createuser.vue?vue&type=template&id=57ff2018&scoped=true"
import script from "./createuser.vue?vue&type=script&lang=js"
export * from "./createuser.vue?vue&type=script&lang=js"
import style0 from "./createuser.vue?vue&type=style&index=0&id=57ff2018&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ff2018",
  null
  
)

export default component.exports